module.exports = __webpack_public_path__ + "img/index_icon1@2x.ad56214d.png";